export function GTMBodyIframe({ gtmId }: { gtmId: string }) {
	return (
		<noscript>
			<iframe
				src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
				height="0"
				width="0"
				title="GTM"
				style={{ display: "none", visibility: "hidden" }}
			/>
		</noscript>
	);
}
